import { render, staticRenderFns } from "./kw_video.vue?vue&type=template&id=24369cc4&scoped=true&"
import script from "./kw_video.vue?vue&type=script&lang=js&"
export * from "./kw_video.vue?vue&type=script&lang=js&"
import style0 from "./kw_video.vue?vue&type=style&index=0&id=24369cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24369cc4",
  null
  
)

component.options.__file = "kw_video.vue"
export default component.exports